import ArrowCircleLeftSharpIcon from "@mui/icons-material/ArrowCircleLeftSharp";
const CustomArrowCircleLeftSharpIcon = () => {
  return <ArrowCircleLeftSharpIcon sx={{ fontSize: "25px" }} />;
};

export default CustomArrowCircleLeftSharpIcon;
